// @flow
import React, {FunctionComponent, useCallback} from 'react';
import {useFieldArray, useForm} from "react-hook-form";
import {FarmData} from "../../api/dtos/breeder-update";
import {Box, Button} from "@mui/material";
import FlexStack from "../Common/flex-stack";
import PersonAddIcon from "@mui/icons-material/PersonAddAlt1";
import SaveIcon from "@mui/icons-material/Save";
import {Widget} from '../Common';
import {HourglassTop} from "@mui/icons-material";
import {AddressFields, FarmDetailsFields, OwnerFields} from "./farm-form-sections";

interface BreederDetailsFormProps {
    onSubmit: (data: FarmData) => void;
    initialData: FarmData;
}

const BreederDetailsForm: FunctionComponent<BreederDetailsFormProps> = ({onSubmit, initialData}) => {
    const {
        formState: {errors, isSubmitting},
        register,
        handleSubmit,
        control,
        watch,
    } = useForm<FarmData>({
        defaultValues: initialData
    });
    const {
        fields,
        append,
        remove
    } = useFieldArray({control, name: "owners"});

    const addOwner = useCallback(() => append({name: ""}), [append]);

    return (
        <Box>
            <form onSubmit={handleSubmit(form => onSubmit(form))} autoComplete="off" noValidate>
                <FlexStack spacing={4}>

                    <Widget displayName="Hofdaten">
                        <FarmDetailsFields register={register} errors={errors} watch={watch}/>
                    </Widget>

                    <Widget displayName="Adresse">
                        <AddressFields register={register} errors={errors}/>
                    </Widget>

                    <Widget displayName="Besitzer"
                            quickActions={[
                                {
                                    icon: <PersonAddIcon/>,
                                    action: addOwner,
                                },
                            ]}>
                        <OwnerFields register={register} errors={errors} fields={fields} addOwner={addOwner}
                                     removeOwner={remove}/>
                    </Widget>

                    <Button variant="contained"
                            startIcon={isSubmitting ? <HourglassTop/> : <SaveIcon/>}
                            type="submit"
                            disabled={isSubmitting}
                    >
                        Speichern
                    </Button>
                </FlexStack>
            </form>
        </Box>
    );
};


export default BreederDetailsForm